export type ErrorPageProps = {
  error: any;
};

export function ErrorPage({ error }: ErrorPageProps): JSX.Element {
  return (
    <div className="h-full m-4">
      <h1>Request failed</h1>
      <pre className="whitespace-break-spaces [word-break:break-word]">{error}</pre>
    </div>
  );
}
